"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["WEB"] = "WEB";
    Environment["NODEJS"] = "NODEJS";
})(Environment || (exports.Environment = Environment = {}));
